import * as React from 'react';
const SvgMediaPlayOutline = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.5 16a.25.25 0 0 0 .373.217l10.603-6a.25.25 0 0 0 0-.434l-10.603-6a.25.25 0 0 0-.373.218zm.739-13.733 11.36 6.428a1.5 1.5 0 0 1 0 2.61l-11.36 6.429A1.5 1.5 0 0 1 4 16.428V3.573a1.5 1.5 0 0 1 2.239-1.306"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMediaPlayOutline;
